"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartEditOrderDetails = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
const labelToClickTextMapping = {
    [enums_1.EventLabelCartEditOrderDetailsEnum.Product]: 'product',
    [enums_1.EventLabelCartEditOrderDetailsEnum.Address]: 'address',
    [enums_1.EventLabelCartEditOrderDetailsEnum.Payment]: 'payment',
    [enums_1.EventLabelCartEditOrderDetailsEnum.Shipping]: 'shipping',
};
function trackCartEditOrderDetails(label, clickUrl) {
    const eventData = labelToClickTextMapping[label]
        ? {
            eventName: enums_1.GA4EventName.ClickEditOrderDetails,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            click_element: labelToClickTextMapping[label],
            click_url: clickUrl,
        }
        : undefined;
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.CartEventType.EditOrderDetails,
        eventLabel: label,
        eventData,
    });
}
exports.trackCartEditOrderDetails = trackCartEditOrderDetails;
//# sourceMappingURL=trackCartEditOrderDetails.js.map